import ActiveSurfaceView from 'mini-calendar-surface-store/lib/store/schema/ActiveSurfaceView';
import getLastActiveCalendarView from './getLastActiveCalendarView';
import { format } from 'owa-strings';

export const VIEW_TYPE_DAY = 'day';
export const VIEW_TYPE_AGENDA = 'agenda';
export const CALENDAR_SURFACE_PATH_TEMPLATE = '/view/{0}';
export const CALENDAR_SURFACE_ROUTE = format(
    CALENDAR_SURFACE_PATH_TEMPLATE,
    `:view(${VIEW_TYPE_DAY}|${VIEW_TYPE_AGENDA})`
);

/**
 * Returns the active calendar surface view's path
 */
export default function getActiveSurfaceViewPath(): string {
    let pathname = null;
    switch (getLastActiveCalendarView()) {
        case ActiveSurfaceView.DAY:
            pathname = VIEW_TYPE_DAY;
            break;
        case ActiveSurfaceView.AGENDA:
        default:
            pathname = VIEW_TYPE_AGENDA;
    }

    return format(CALENDAR_SURFACE_PATH_TEMPLATE, pathname);
}

export const getActiveSurfaceViewForViewParam = (view: 'day' | 'agenda') => {
    switch (view) {
        case 'day':
            return ActiveSurfaceView.DAY;
        case 'agenda':
        default:
            return ActiveSurfaceView.AGENDA;
    }
};
